export default __webpack_public_path__ + "static/media/Multilingual.3977a9b1.svg";